import metadata from '../assets/avatar-motion/final-three.json';
import chickRollMeta from '../assets/avatar-motion/baby-chick-roll/clip-meta.json';
import chickIdleToRun from '../assets/avatar-motion/baby-chick-roll/baby-chick-idle-to-run.webp';
import chickIdleToRunStill from '../assets/avatar-motion/baby-chick-roll/baby-chick-idle-to-run.static.webp';
import chickRunning from '../assets/avatar-motion/baby-chick-roll/baby-chick-running.webp';
import chickRunningStill from '../assets/avatar-motion/baby-chick-roll/baby-chick-running.static.webp';

const files = import.meta.glob('../assets/avatar-motion/{ghost,robot,baby-chick}/*.webp', {
  eager: true, query: '?url', import: 'default',
});
const names = ['idle', 'running', 'correct', 'wrong', 'idleToRun', 'runToIdle', 'ready', 'taunt', 'celebrate'];
const filename = (name) => name.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`);
export function finalThreeAsset(id, name) {
  return files[`../assets/avatar-motion/${id}/${id}-${name}.webp`] ?? null;
}

export const FINAL_THREE = metadata.map(({ id, emoji, headBox, durations }) => ({
  emoji,
  assets: {
    ...Object.fromEntries(names.flatMap((name) => [
      [name, finalThreeAsset(id, filename(name))],
      [`${name}Still`, finalThreeAsset(id, `${filename(name)}.static`)],
    ])),
    head: finalThreeAsset(id, 'head'),
    headBox,
    ...(id === 'baby-chick' && {
      idleToRun: chickIdleToRun,
      idleToRunStill: chickIdleToRunStill,
      idleToRunPlacement: chickRollMeta.placement,
      running: chickRunning,
      runningStill: chickRunningStill,
      runningPlacement: chickRollMeta.placement,
    }),
  },
  ms: names.map((name) => (id === 'baby-chick' && ['idleToRun', 'running'].includes(name)
    ? chickRollMeta.durations[name] : durations[name]) ?? 0),
}));

export const FINAL_THREE_EGGS = Object.fromEntries(metadata.map(({ id, emoji, durations }) => [
  emoji, Object.freeze([Object.freeze({ id: 'egg1', src: finalThreeAsset(id, 'egg1'), ms: durations.egg1 })]),
]));
